import { SvgIcon } from "@material-ui/core";

export const SquareIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="">
      <rect width="100%" height="100%" rx="2" ry="2" fill="#E6E6E6" />
    </SvgIcon>
  );
};
